import { rgba as polishedRGBA } from 'polished'
import { css, styled } from 'styled-components'

import { Body } from '@nx/fire/typography'

export const StyledInfoContainer = styled.div<{ $level: 'INFO' | 'ERROR' }>`
  ${({ theme, $level }) => {
    const colour =
      $level === 'INFO'
        ? theme.colours.primary.charcoal
        : theme.colours.status.error

    return css`
      background: ${polishedRGBA(colour, 0.1)};
      display: flex;
      flex-direction: row;
      gap: 10px;
      margin: 20px 0;
      padding: 10px 15px 15px;

      * {
        color: ${colour};
      }

      a {
        text-decoration: underline;
      }
    `
  }}
`

export const StyledInfoIcon = styled.svg<{
  $level: 'INFO' | 'ERROR'
}>`
  ${({ theme, $level }) => {
    const colour =
      $level === 'INFO'
        ? theme.colours.primary.charcoal
        : theme.colours.status.error

    return css`
      border: 2px solid ${colour};
      border-radius: 100%;
      flex-shrink: 0;
      height: 20px;
      padding: 2px;
      width: 20px;
    `
  }}
`

export const StyledBody = styled(Body)`
  margin: 0;
`
